import React, { useState } from "react";
import { Link } from "react-router-dom";

import AuthLayout, { Icon } from "../AuthLayout";
import { hasPasswordErrors, passwordErrors } from "../../../utils/password";
import "./account.css";

/*
 * Pages de compte hors connexion (mot de passe oublié, lien envoyé,
 * nouveau mot de passe, désabonnement) : même cadre que la connexion
 * (AuthLayout), même panneau illustré.
 */

export const AccountLayout = ({ t, children }) => (
  <AuthLayout
    t={t}
    eyebrow={t("Laundry & dry-cleaning")}
    title={t("Your laundry, picked up where you left it.")}
    lede={t("WOSH collects, cleans and returns your clothes, fresh and folded.")}
    chip={{ icon: "i-store", label: t("Connect with your local laundry store") }}
  >
    {children}
  </AuthLayout>
);

/** Pastille ronde au-dessus d'un titre d'état (courrier envoyé, succès, lien expiré). */
export const StatusBadge = ({ icon, tone = "brand" }) => (
  <span className={`wosh-acc__badge wosh-acc__badge--${tone}`}>
    <Icon name={icon} />
  </span>
);

export const BackToSignIn = ({ t }) => (
  <p className="wosh-auth__switch">
    <Link to="/sign-in">{t("Back to sign in")}</Link>
  </p>
);

/**
 * Nouveau mot de passe + confirmation, avec œil pour afficher. Les erreurs
 * apparaissent après le premier envoi ; `onSubmit(password, confirmation)`
 * n'est appelé que sur un formulaire valide.
 */
export function PasswordForm({ t, cta, submitting, onSubmit }) {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [shown, setShown] = useState(false);
  const [attempted, setAttempted] = useState(false);

  const errors = passwordErrors({ password, confirmation });
  const show = (key) => (attempted && errors[key] ? t(errors[key]) : null);

  const submit = (event) => {
    event.preventDefault();
    setAttempted(true);
    if (hasPasswordErrors(errors) || submitting) return;
    onSubmit(password, confirmation);
  };

  const field = (id, label, value, setValue, error, autoComplete) => (
    <>
      <label className="wosh-auth__label" htmlFor={id}>
        {label}
      </label>
      <div className={`wosh-auth__field${error ? " wosh-auth__field--invalid" : ""}`}>
        <Icon name="i-lock" />
        <input
          id={id}
          type={shown ? "text" : "password"}
          autoComplete={autoComplete}
          placeholder="••••••••"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
        <button
          type="button"
          className={`wosh-auth__reveal${shown ? " wosh-auth__reveal--on" : ""}`}
          onClick={() => setShown(!shown)}
          aria-label={t("Show/Hide Password")}
        >
          <Icon name="i-eye" />
        </button>
      </div>
      {error && <p className="wosh-auth__error">{error}</p>}
    </>
  );

  return (
    <form onSubmit={submit} noValidate>
      {field("accPassword", t("New password"), password, setPassword, show("password"), "new-password")}
      <div className="wosh-acc__gap" />
      {field(
        "accConfirmation",
        t("Confirm the password"),
        confirmation,
        setConfirmation,
        show("confirmation"),
        "new-password"
      )}
      <button type="submit" className="wosh-auth__cta wosh-acc__cta" disabled={submitting}>
        {submitting && <span className="wosh-auth__spinner" />}
        {submitting ? t("processing") : cta}
      </button>
    </form>
  );
}
